var assetPath = '';

var isMobile;

var aspectRatio = 1.777;

var ss_timeout = 25000;
var galleryTypes = 'video,img,canvas'
var w = window.innerWidth;
var h = window.innerHeight;
var isFlickityInitialized = false;
var at_media_data = []; 
var at_html_data = {};
var at_callbacks = [];
var at_data_requested = false;
bg_key = ''
var backgrounds = {}
var londonWeatherData = null;
var dataConsole = null;
window.backgrounds = backgrounds

var climateWaypoints = []

var weatherApiKey = '705a22e689f9613a9a709ac814037ea0'

// THREE VARS
var container, stats;
var camera, scene, outscene, renderer;
var morph, small, large, og_morph;
var mixers;
var clock = new THREE.Clock();
var mouse = new THREE.Vector2(), INTERSECTED;
var uniforms;
var iceMeltState = 0.05; // 1 = melted (no ice)

$(document).ready(function(){

    if ( WEBGL.isWebGLAvailable() === false ) {
        document.body.appendChild( WEBGL.getWebGLErrorMessage() );
    }

    getAirtableData(() => {
      if (Object.keys(backgrounds).length == 0) {
        setupBackgroundScenes()   
      }
      Waypoint.refreshAll();
    })

	if(mobileAndTabletcheck()) {
		isMobile = true;
	} else {
		isMobile = false;
	}

	if(isMobile) {
		$('body').addClass('mobile');
	} else {
		// Force to top of page
		$(window).on('beforeunload', function() {
			$(window).scrollTop(0);
		});
		$(document).scrollTop(0);
	}

    // Make media gaps clickless
    if(!isMobile) {
    	$('.media-gap').closest('.row').css({'pointer-events': 'none'});
    	$('.media-gap').closest('.columns').css({'pointer-events': 'none'});
    } else {
    	$('.media-gap').closest('.columns').css({'padding-left': '0', 'padding-right': '0'});
		$('.media-gap').closest('.row').css({'padding-left': '0', 'padding-right': '0'});
		$('.medium-offset-5').removeClass('medium-offset-5 medium-7 large-offset-4 large-8');
    }

    // INIT GAP
    $('#media-gap-2').css('height', '800vh')
    Waypoint.refreshAll();

	// Tooltips
	$('[data-caption!=""]').qtip({ // Grab all elements with a non-blank data-caption attr.
		content: {
			attr: 'data-caption' // Tell qTip2 to look inside this attr for its content
		},
		position: {
			target: 'mouse',
			adjust: {
				mouse: true  // Can be omitted (e.g. default behaviour)
			}
		}
	});

	// Mobile Nav
	$('#navigation').slicknav({
		label: "",
		closeOnClick: true
	});
	if(isMobile) {
		$('.slicknav_menu').css('display', 'block');
	}

	// Legal notice
	$('#legal-bt').click(function() {
		var $legalInfo = $('#legal .press-item');
		var $arrow = $('#legal .arrow');
		if($legalInfo.hasClass('hidden')) {
			$legalInfo.removeClass('hidden');
			$arrow.addClass('down');
			$.scrollTo(this, 500, {
				easing: 'easeOutQuad',
				offset: -57
			});
			return false;
		} else {
			$legalInfo.addClass('hidden');
			$arrow.removeClass('down');
		}
	});

    // Sources
	$('#sources-bt').click(function() {
		var $sourcesInfo = $('#sources .press-item');
		var $arrow = $('#sources .arrow');
		if($sourcesInfo.hasClass('hidden')) {
			$sourcesInfo.removeClass('hidden');
			$arrow.addClass('down');
			$.scrollTo(this, 500, {
				easing: 'easeOutQuad',
				offset: -57
			});
			return false;
		} else {
			$sourcesInfo.addClass('hidden');
			$arrow.removeClass('down');
		}
	});

	// Click to scroll to info section
	$('.scrollto').click(function(e){
        var elId = $(this).data('scrollto')
        var el = document.getElementById(elId)
		$.scrollTo(el, 650, {
			easing: 'easeOutQuad',
			//offset: -20, 
			offset: elId == 'media-gap-3' ? 0 : -20
		});
		return false;
	});

	// Screensaver Functionality
	var s_saver;

	if(!isMobile) {
		function onUserAction() {
			clearTimeout(s_saver);
			s_saver = setTimeout(function(){
				$('#content-panel-1').stop().fadeTo(2500, 0);
			}, ss_timeout);
			$('#content-panel-1').stop().fadeTo(100, 1);
		}
		$('body').on('mousemove', onUserAction);
		$(window).on('scroll', onUserAction);
	}

	// Init bg intro video
	if(isMobile) {
    $('#media-gap-0').hide()
		$('.media-gallery').replaceWith('<div class="mobile-intro-bg"></div>');
    initSlideshow('#media-gap-1', 'slideshow1', aspectRatio, true) // call the next two as callbacks?
    initSlideshow('#media-gap-2', 'slideshow2', aspectRatio, true);
    initSlideshow('#media-gap-3', 'slideshow3', aspectRatio, true);
	} else {
		initSlideshow('.media-gallery', 'slideshowIntro', aspectRatio, false);
    playSlideshow('.media-gallery');
	}

	// Init social buttons
	$('.twitter-popup').click(function(event) {
		var width  = 575,
		    height = 400,
		    left   = ($(window).width()  - width)  / 2,
		    top    = ($(window).height() - height) / 2,
		    url    = this.href,
		    opts   = 'status=1' +
		             ',width='  + width  +
		             ',height=' + height +
		             ',top='    + top    +
		             ',left='   + left;

		window.open(url, 'twitter', opts);
		return false;
	});

	$('.facebook-popup').click(function(event) {
		var width	= 400,
			height	= 300,
			left 	= (window.screen.width / 2) - ((width / 2) + 10),
			top  	= (window.screen.height / 2) - ((height / 2) + 50);
		var windowFeatures = "status=no,height=" + height + ",width=" + width + ",resizable=yes,left=" + left + ",top=" + top + ",screenX=" + left + ",screenY=" + top + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";
		var u = location.href;
		var t = document.title;
		window.open('https://www.facebook.com/sharer.php?u='+encodeURIComponent(u)+'&t='+encodeURIComponent(t),'sharer', windowFeatures);
		return false;
	});

	// Handle window resize
	if(!isMobile)
		initWaypoints();

	$(window).on('resize', function() {
		resizeSlideshow();
		if(!isMobile)
			Waypoint.refreshAll();
	}).trigger('resize');

	// Fade in

	$('.logo-stroke-white').delay(3000).fadeTo(5000, 0);
  Waypoint.refreshAll()

  // SETUP THREE
  trying_to_setup = setInterval( attach_if_ready , 1000)

  if (!isMobile) {
    getAirtableData( () => { 
      loadSlideshowFromTemplate('#slideshow-inline', 'slideshow1',  aspectRatio, true)
    })
    window._V_ = _V_
  }
});

function getAirtableData(callback) {

  at_callbacks.push(callback)
  if (at_media_data.length != 0) {
    at_callbacks.forEach((cb) => {cb()})
    at_callbacks = []
    return
  }

  if (at_data_requested) {
    return
  } else {
    at_data_requested = true
  }
  at_media_data = []
  at_html_data = {}
  window.at_media_data = at_media_data
  window.at_html_data = at_html_data
  var typeFunc = {
    'html': ( e ) => {if ('html' in e) {$('#'+e.id).html(e.html); at_html_data[e.id]=e.html}},
    'slideshow': ( e ) => {if ('video' in e) { at_media_data.push(e) }}
  }

  dataTypes = Object.keys(typeFunc)
  apiKey = 'keyJLphBGupIn2AC0'
  dataTypes.forEach( (dataType, i) => {
    airtableURL = 'https://api.airtable.com/v0/appreTVJ5YHFpiVmS/'+dataType+'?api_key='+apiKey
    $.get( airtableURL,  function (data, textStatus, jqXHR) {  // success callback
      window.data = data
      insertAirtableData( data, typeFunc[dataType] )
      if (callback && i==dataTypes.length-1) {
        // END
        at_callbacks.forEach((cb) => {cb()})
        at_callbacks = []
      }
    })
  })
}

function insertAirtableData( data, func ) {
  data.records.forEach( ( record ) => {
    fields = record.fields
    func(fields)
  })
}

function destroySlideshow(gallerySelector) {

	if(!isMobile) {
		try {
			//destroy videojs players
			$.each(_V_.players, function(key, player) {
        //if (!key.includes('video_1_')){
        if (true) {
          if(player != null) {
            player.dispose();
          } else {
            delete _V_.players[key];
          }
        }
			});

			//destroy flickity
            if (isFlickityInitialized) {
              $(gallerySelector).flickity('destroy');
              isFlickityInitialized = false;
            }

			//empty
			$(gallerySelector).empty();

		} catch(e) {
			console.log('Cound not destroy slideshow');
		}
	}
}

function setupSlideshow(gallerySelector, slideshowName, aspectRatio, shouldShowControls, callback) {
    resizeSlideshow();
    var slideCount = $(gallerySelector).find('img, video').length;
    $(gallerySelector).each(function() {

        var showControls, shouldWrap, showDots;
        if(shouldShowControls !== undefined && shouldShowControls === false) {
            showControls = false;
            shouldWrap = true;
            showDots = false;
        } else {
            showControls = true;
            shouldWrap = false;
            if(slideCount < 2) {
                showDots = false;
            } else {
                showDots = true;
            }
        }

        // Init flickity slideshow
        var res = $(this).flickity({
            cellAlign: 'left',
            imagesLoaded: true,
            prevNextButtons: false,
            pageDots: showDots,
            wrapAround: shouldWrap,
            draggable: true,
            contain: true
        });
        isFlickityInitialized = true;

        this.lastIndex = 0;

        // Add arrow UI elements
        if(showControls) {
            var $viewport = $(this).find('.flickity-viewport');
            var $left, $right;
            if(!isMobile) {
                $viewport.append('<span class="arrow arrow--left media-gallery-left"></span><span class="arrow arrow--right media-gallery-right"></span>');
                $left = $viewport.find('.media-gallery-left');
                $right = $viewport.find('.media-gallery-right');
                $left.hide();
                if($(this).find('.gallery-cell').length <= 1) {
                    $right.hide();
                }
            }

            // Handle arrow left click
            $viewport.find('.media-gallery-left').click(function() {
                var $gallery = $(this).closest(gallerySelector);
                $gallery.flickity('previous');
                $gallery.find('.media-gallery-right').show();
                var flkty = $gallery.data('flickity');
                if(flkty.selectedIndex === 0) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
                var $gallery = $(this).closest('.media-gallery');
                var flkty = $gallery.data('flickity');
                onSelected(flkty.selectedIndex, $gallery[0]);
                $gallery[0].lastIndex = flkty.selectedIndex;
            });

            // Handle arrow right click
            $viewport.find('.media-gallery-right').click(function() {
                var $gallery = $(this).closest(gallerySelector);
                $gallery.flickity('next');
                $gallery.find('.media-gallery-left').show();
                var flkty = $gallery.data('flickity');
                var len = $gallery.find('.gallery-cell').length;
                if(flkty.selectedIndex === len - 1) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
                var $gallery = $(this).closest('.media-gallery');
                var flkty = $gallery.data('flickity');
                onSelected(flkty.selectedIndex, $gallery[0]);
                $gallery[0].lastIndex = flkty.selectedIndex;
            });

            // Handle drag events event
            $(this).on('dragStart', function(event, pointer) {
                var flkty = $(this).data('flickity');
                var $slides = $(this).find('img, video');
                var current = $slides[flkty.selectedIndex];
                if(current.nodeName === 'VIDEO') {
                    var id = $(current).attr('id');
                    videojs(id).pause();
                }
                if(isMobile) {
                    this.allowVideoPlay = false;
                }
            });
            $(this).on( 'dragEnd', function( event, pointer ) {
                var flkty = $(this).data('flickity');
                if(!isMobile) {
                    var $left = $(this).find('.media-gallery-left');
                    var $right = $(this).find('.media-gallery-right');
                    if(this.lastIndex < flkty.selectedIndex) {
                        $left.show();
                        var flkty = $(this).data('flickity');
                        var len = $(this).find('.gallery-cell').length;
                        if(flkty.selectedIndex === len - 1) {
                            $right.hide();
                        } else {
                            $right.show();
                        }
                    } else if(this.lastIndex > flkty.selectedIndex) {
                        $right.show();
                        var flkty = $(this).data('flickity');
                        if(flkty.selectedIndex === 0) {
                            $left.hide();
                        } else {
                            $left.show();
                        }
                    }
                }
                if(this.lastIndex !== flkty.selectedIndex) {
                    onSelected(flkty.selectedIndex, this);
                    this.lastIndex = flkty.selectedIndex;
                }
                if(isMobile) {
                    var me = this;
                    setTimeout(function() {
                        me.allowVideoPlay = true;
                    }, 10);
                }
            });

        }

        // Don't init videojs on mobile
        if(isMobile) {
            $('video').removeAttr('data-setup');
            $('video').removeClass('video-js');
        }

        $(this).find('video').each(function(index) {
            var id = $(this).attr('id');
            var v = this;

            (function(id, index) {

                videojs(id, {"autoplay":true}).ready(function() {

                    var vId = this.Qa;
                    var v = $('#' + vId).find('video');
                    var vp = $('#' + vId).find('.vjs-poster');

                    // Video tooltips
                    $('[data-caption!=""]').qtip({
                        content: {
                            attr: 'data-caption'
                        },
                        position: {
                            target: 'mouse',
                            adjust: {
                                mouse: true
                            }
                        }
                    });

                    resizeSlideshow();
                    var player = this;
                    if(!showControls) {
                        // Hide videojs controls
                        $(v).closest('.video-js').find('.vjs-control-bar, .vjs-big-play-button').remove();
                        
                    }
                    if(index === 0) {
                      //player.play();
                    }
                    // Hide fullscreen
                    $(v).closest('.video-js').find('.vjs-fullscreen-control').remove();
                    if(!isMobile) {
                        // Handle video end event (Go to next slide)
                        (function(videoId) {
                            player.on('ended', function() {
                                var $gallery = $('#'+videoId).closest('.media-gallery');
                                $gallery.flickity('next');
                                var flkty = $gallery.data('flickity');
                                onSelected(flkty.selectedIndex, $gallery[0]);
                                $gallery[0].lastIndex = flkty.selectedIndex;
                            });
                        })(id);
                    } else {
                        // Hide controls for mobile
                        $(v).closest('.video-js').find('.vjs-control-bar').remove();
                        $(v).closest('.video-js').children().css('pointer-events', 'none');
                        $(v).closest('.gallery-cell')
                        .on('click', function() {
                            if($(v).closest('.media-gap')[0].allowVideoPlay) {
                                if($(v).closest('.video-js').hasClass('vjs-playing')) {
                                    player.pause();
                                } else {
                                    player.play();
                                }
                            }
                        });
                    }
                });
            })(id, index);
		});
		if(callback) {
            callback();
        }

      });
}

function buildGalleryCellHTML( template, params) {
  template = template.replace('<<SRC>>',params.src_url)
  template = template.replace('<<POSTER>>',params.poster_url)
  template = template.replace('<<ID>>',params.video_id)
  return template
}

function buildCellHTML( e ) {

    var galleryCell = $('<div class="gallery-cell"><div>')
    var cellTitle = $('<div class="cell-title"><div>')

    if (!isMobile) galleryCell.append(cellTitle)

    cellTitle.html(e.text)
    var src_url = e.video[0].url
    var url_parts = src_url.split('.')
    var url_ext = url_parts[url_parts.length-1]
    var item_id = 'video_'+e.slideshow_id + '_' + e.id
    var poster_url = e.poster ? e.poster[0].url : ''
    if (['mp4','m4v','mov'].indexOf(url_ext) != -1) {
      var videoBase = $('<video width="auto" height="auto" controls="controls" data-setup="{&quot;autoplay&quot;: false}" class="video-js vjs-sublime-skin"></video>') 
      videoBase.attr({
        'id':item_id,
        'src':src_url,
        'poster':poster_url
      })
      galleryCell.append(videoBase)
    } else {
      var imgBase = $('<img width="auto" height="auto"></img>')
      imgBase.attr({
        'id':item_id,
        'src':src_url
      })
      galleryCell.append(imgBase)
    }
    return galleryCell[0].outerHTML;
}

function buildMobileClimateVisHTML() {
  var climateRows = []
  at_media_data.forEach( (e) => {
    if (['video','graph'].includes(e.slideshow_id) && !(e.slideshow_id=='video' && e.id=='3')) {
      climateRows.push(e)
    }
  })
  climateRows.sort((a,b) =>{
    var rank = (e) => { 
      return (e.slideshow_id=='video' ? 0:10) + parseInt(e.id)
    }
    return rank(a) - rank(b)
  })
  var html = ''
  var slideDescs = []
   
  Object.keys(at_html_data).forEach( (html_id) => {
    if (html_id.includes('climate-info-slide')) {
      slideDescs.push(at_html_data[html_id])
    }
  })

  climateRows.forEach((e,i) => {
    var cell = $(buildCellHTML( e ))
    var cellHTML;
    if (cell.find('img')[0]) {
      //cell.toggleClass('gallery-cell')
      cell.css({height:'auto'})
      cellHTML = cell[0].outerHTML
    } else {
      cellHTML = cell[0].outerHTML
    }
    html += cellHTML

    // INSERT DESCRIPTION (real dirty now)
    var descBaseHTML = '<div class="row full-width white"><div class="columns small-12"><section class="content-section" id="vis-desc-'+i+'">DESCP</section></div></div>' 
    var desc = $(descBaseHTML)
    var sec = $($($(desc).children()[0]).children()[0])
    sec.text(slideDescs[i])
    html += desc[0].outerHTML
  })
  return html
}

function buildGalleryHTML( slideshowName ) {
  html = ''
  var ordered_at_slide_data = []
  at_media_data.forEach( (e) => {
    if ('slideshow' + e.slideshow_id == slideshowName) {
      ordered_at_slide_data.push(e)
    }
  })

  ordered_at_slide_data = ordered_at_slide_data.sort((a,b) => {return parseInt(a.id) - parseInt(b.id)})

  ordered_at_slide_data.forEach( (e) => {
    if ('slideshow' + e.slideshow_id == slideshowName) {
      html += buildCellHTML( e )
    }
  })
  return html
}

function loadSlideshowFromTemplate(gallerySelector, slideshowName, aspectRatio, shouldShowControls, callback) {
  html = buildGalleryHTML( slideshowName) 
  $(gallerySelector).html(html)
  setupSlideshow(gallerySelector, slideshowName, aspectRatio, shouldShowControls, callback)
}

function loadTemplate(url, callback) {
  $.ajax({url:url, success: (data) => {
    callback(data)
  }})
}

function setupBackgroundScenes() {
  // Setup Simple Background Divs 
  // setup three scene 
  window.backgrounds = backgrounds
  var bg1 = $('<div class="three-frame"></div>')
  backgrounds['three'] = bg1
  bg1.css({
    width:w,
    height:h,
    position: 'fixed'
  })
  $('body').append(bg1)

}

function displayThree(gallerySelector){
  bg_key = 'three'
  $(gallerySelector).append(backgrounds['three'])
}
function hideThree(){
  bg_key = ''
  if (backgrounds['three'])
    backgrounds['three'].remove()
}

function initSlideshow(gallerySelector, slideshowName, aspectRatio, shouldShowControls, callback) {
	var url = window.location.href + 'partials/' + slideshowName + '.html';
	(function(gallerySelector, slideshowName, aspectRatio, shouldShowControls, callback) {
        hideThree()
        
        if (false && !isMobile && slideshowName == 'slideshow1') {
          // DISABLED
          displayThree(gallerySelector)
          if (callback) callback()
        } else if ('slideshowIntro' == slideshowName) {
          $(gallerySelector).load(url, function() {
            setupSlideshow(gallerySelector, slideshowName, aspectRatio, shouldShowControls, callback)
          });
        } else if (!isMobile && slideshowName == 'slideshow2') {
          getAirtableData( () => { initClimateVis(gallerySelector); if (callback) callback() })
          if (callback) callback()
        } else if (isMobile && slideshowName == 'slideshow2') {
          getAirtableData( () => { initClimateVisMobile(gallerySelector); if (callback) callback() })
        } else {
          getAirtableData( () => { 
            loadSlideshowFromTemplate(gallerySelector, slideshowName, aspectRatio, shouldShowControls, callback)
          })
        }

	})(gallerySelector, slideshowName, aspectRatio, shouldShowControls, callback);
}

function onSelected(index, galleryElement) {

	var $slides = $(galleryElement).find('img, video');
	var lastIndex = galleryElement.lastIndex;
	var element = $slides.eq(index)[0];
	var prevElement = $slides.eq(lastIndex)[0];
	var firstElement = $slides.eq(0)[0];

	if(index !== lastIndex) {
		if(prevElement.nodeName === 'VIDEO') {
				// Pause previous video
				var id = $(prevElement).attr('id');
				videojs(id).pause();
			}
			if(element.nodeName === 'VIDEO') {
				if(!isMobile) {
					// Play current video
					var id = $(element).attr('id');
					videojs(id).play();
				}
			}
		}
	}

	function resizeSlideshow() {

		var ww = $(window).width();
		var wh = $(window).height();
		var a = ww / wh;

		var w, h, t, l;
		if(isMobile) {
			w = ww;
			h = w / aspectRatio;
			t = 0;
			l = 0;

			$('.media-gap, .flickity-viewport, .gallery-cell').css({
				'width': w + 'px',
				'height': h + 'px'
			});

			$('.gallery-cell img').parent().css({
				'width': w + 'px',
                height: 'auto'
			})

			$('.gallery-cell div.video-js, .gallery-cell div.img-wrapper').css({
				'width': w + 'px',
				'height': h + 'px',
				'top': '0',
				'left': '0'
			});

			$('.gallery-cell img, .gallery-cell video').css({
				'width': w + 'px',
				'height': 'auto'
			});

		} else {
			if(aspectRatio > a) {
			//media wider than screen, match by height
			h = wh;
			w = wh * aspectRatio;
			t = 0;
			l = (ww - w) * 0.5;
		} else {
			//screen wider than media, match by width
			w = ww;
			h = ww / aspectRatio;
			t = (wh - h) * 0.5;
			l = 0;
		}

		$('.media-gallery, .flickity-viewport, .gallery-cell').css({
			'width': ww + 'px',
			'height': wh + 'px'
		});

		$('.gallery-cell div.video-js, .gallery-cell div.img-wrapper').css({
			'width': w + 'px',
			'height': h + 'px',
			'top': t + 'px',
			'left': l + 'px'
		});

		$('.gallery-cell img, .gallery-cell video').css({
			'width': w + 'px',
			'height': 'auto'
		});

		$('.vjs-control-bar').css({
			'bottom': -t + 'px',
			'left': -l + 'px',
			'right': -l + 'px'
		});
	}
}

function setTitle( e ) {
  if (e) $('.climate-title').html(e.text)
}

function displayClimateGraph(graphData,graphId) {
  $('.climate-video, .climate-graph').hide(); $('#climate-video-3').show()
  $('#climate-graph-'+graphId).show(); 
  setTitle(graphData[graphId])
}
function displayClimateVideo(videoData,id) {
  $('.climate-video, .climate-graph').hide();
  $('#climate-video-'+id).show(); 
  setTitle(videoData[id])
}
function goToClimateVisSection( i, buttonEl ) {
  var nSections = 5
  var climateVisHeight = $('#media-gap-2').height()-window.innerHeight
  var sectionHeight = climateVisHeight/nSections; // 5 is the number of sections
  $('html, body').animate({ scrollTop: $('#media-gap-2').offset().top + sectionHeight*(i+.4)}, 500);
}

function initClimateVisMobile(containerSelector) {
  var html = buildMobileClimateVisHTML() 
  var $container = $(containerSelector)
  $container.html(html)
  $container.css({
    height: 'auto',
    //overflow: 'auto',
    display: 'block'
  })
  $container.children().css({
    float: 'left',
    height: 'auto',
    position: 'static'   
  })
}

function initClimateVis(containerSelector) {

  var $container = $(containerSelector)
  // a video in bg, a bunch of icons on the right
    
  var videoData = {}
  var graphData = {}
  loadTemplate("templates/climateTemplate.txt", (template) => {
    at_media_data.forEach((e) => {
      if (e.slideshow_id == 'video') {
        if (['1','2','3'].indexOf(e.id) != -1) {
          videoData[e.id] = e
          var token = '<<SRC-'+e.id+'>>'
          template = template.replace(token,videoData[e.id].video[0].url)
        }
      }
      if (e.slideshow_id == 'graph') {
        if (['1','2','3'].indexOf(e.id) != -1) {
          graphData[e.id] = e
          var token = '<<SRC-G'+(e.id)+'>>'
          template = template.replace(token,graphData[e.id].video[0].url)
        }
      }
    })
    $container.html(template)
    $('#climate-video-1')[0].play()
    $('#climate-video-2')[0].play()
    $('#climate-video-3')[0].play()
    $('#climate-video-2').hide()
    $('#climate-video-3').hide()
    
    $('.climate-graph').hide() 

    var nSections = 5
    var climateVisHeight = $('#media-gap-2').height()-window.innerHeight
    var sectionHeight = climateVisHeight/nSections; // 5 is the number of sections
    var panelHeight = $('.climate-button-panel').height()
    var buttonHeight = $('.climate-button').height()
    var currentSection = -1;
    var sectionId;

    $('#climate-button-1').click(() => { goToClimateVisSection(0,$('#climate-button-1')) })
    $('#climate-button-2').click(() => { goToClimateVisSection(1,$('#climate-button-2')) })
    $('#climate-button-3').click(() => { goToClimateVisSection(2,$('#climate-button-3')) })
    $('#climate-button-4').click(() => { goToClimateVisSection(3,$('#climate-button-4')) })
    $('#climate-button-5').click(() => { goToClimateVisSection(4,$('#climate-button-5')) })

    // ugh
    window.onscroll = () => {
      if ($('.climate-slider')[0]) {
        panelHeight = $('.climate-button-panel').height()
        buttonHeight = $('.climate-button').height()
        var gapTop = $('#media-gap-2').offset().top
        var climateProgress = ($(window).scrollTop()-gapTop)/(climateVisHeight-window.innerHeight)
        $('.climate-slider').css('top',(panelHeight-(buttonHeight))*climateProgress*1.06)
        // Move Climate Info Slider
        var sectionProgress = ($('.climate-slider').offset().top - $('.climate-button-panel').offset().top)/(buttonHeight+10)
        sectionId = sectionProgress | 0
        if (currentSection != sectionId) {
          currentSection = sectionId
          var info = at_html_data['climate-info-slide-'+(sectionId+1)]
          $('.climate-info-slide').html(info)
          $('.button-is-selected').toggleClass('button-is-selected')
          $('#climate-button-'+(sectionId+1)).toggleClass('button-is-selected')
        }
        if (currentSection < nSections) {
          var infoTop = window.innerHeight - ((sectionProgress%1))*window.innerHeight*2 
          $('.climate-info-slide').css('top',infoTop)
        }
      }
    }

    displayClimateVideo(videoData, '1')

    climateWaypoints.forEach((e) => {e.destroy()})
    climateWaypoints = []

    var waypointTransitions = [
      [
      (i) => {displayClimateVideo(videoData, '2')},
      (i) => {displayClimateVideo(videoData, '1')},
      ],
      [
      (i) => {displayClimateGraph(graphData, '1')},
      (i) => {displayClimateVideo(videoData, '2')},
      ],
      [
      (i) => {displayClimateGraph(graphData, '2')},
      (i) => {displayClimateGraph(graphData, '1')}
      ],
      [
      (i) => {displayClimateGraph(graphData, '3')},
      (i) => {displayClimateGraph(graphData, '2')}
      ],
    ]

    waypointTransitions.forEach( (fxs, i) => {
      var wp = new Waypoint({
          element: $('#media-gap-2')[0],
          handler: function(direction) {
              if(direction === 'down') {
                fxs[0]()
              } else {
                fxs[1]()
              }
          }, 
          offset: () => {
            return -sectionHeight*(i+1);
          }
      });   
      climateWaypoints.push(wp)
    })

  })
}

function initWaypoints() {
	// Intro text top (toggle video)
	new Waypoint({
		element: $('#intro-text').closest('.row')[0],
		handler: function(direction) {
			if(direction === 'up') {
				destroySlideshow('.media-gallery');
				initSlideshow('.media-gallery', 'slideshowIntro', aspectRatio, false);
        playSlideshow('.media-gallery');
        $('.logo-stroke-red, .logo-stroke-white').show();
        //whiteNav()
        //hideNav()
        
			} else {
        destroySlideshow('.media-gallery');
        whiteNav()
				initSlideshow('.media-gallery', 'slideshow1', aspectRatio, true, function() {
					if(!isMobile) {
            playSlideshow('.media-gallery');
					}
				});
				$('.logo-stroke-red, .logo-stroke-white').hide();
			}
		}
  });
  
  // Project info middle (swap slideshows)
	new Waypoint({
		element: $('#media-gap-1')[0],
		handler: function(direction) {
			if(direction === 'up') {
				if(!isMobile) {
          //whiteNav()
          hideNav()
                }
			} else {
				if(!isMobile) {
          whiteNav();
          showNav()
                }
			}
		},
		offset: function() {
			return h;
		}
	});


	// Project info top (play/pause slideshow 1)
	new Waypoint({
		element: $('#project-info').closest('.row')[0],
		handler: function(direction) {
			if(direction === 'up') {
				if(!isMobile) {
					// hideNav();
          playSlideshow('.media-gallery');
          whiteNav()
				}
			} else {
				if(!isMobile) {
					// showNav();
          stopSlideshow('.media-gallery');
          whiteNav()
				}
			}
		},
            offset: function() {
                //return ($(window).height() - $(this.element).height()) * 0.5;
                return 0;
			}
	});

	// Project info middle (swap slideshows)
	new Waypoint({
		element: $('#media-gap-2')[0],
		handler: function(direction) {
			if(direction === 'up') {
				if(!isMobile) {
                  destroySlideshow('.media-gallery');
                  initSlideshow('.media-gallery', 'slideshow1', aspectRatio, true, function() {
                      // playSlideshow('.media-gallery');
                  });
                }
			} else {
				if(!isMobile) {
                  destroySlideshow('.media-gallery');
                  initSlideshow('.media-gallery', 'slideshow2', aspectRatio, true, function() {
                      // playSlideshow('.media-gallery');
                  });
                }
			}
		},
		offset: function() {
			return h;
		}
	});

	// Project info bottom (play/pause slideshow 2)
	new Waypoint({
		element: $('#project-info').closest('.row')[0],
		handler: function(direction) {
			if(direction === 'down') {
				if(!isMobile) {
					// hideNav();
					playSlideshow('.media-gallery');
				}
			} else {
				if(!isMobile) {
					// showNav();
					stopSlideshow('.media-gallery');
				}
			}
		},
		offset: 'bottom-in-view'
	});

	// Climate facts top (play/pause slideshow 1)
	new Waypoint({
		element: $('#climate-facts').closest('.row')[0],
		handler: function(direction) {
			if(direction === 'up') {
				if(!isMobile) {
          whiteNav();
					playSlideshow('.media-gallery');
				}
			} else {
				if(!isMobile) {
					// showNav();
          redNav();
					stopSlideshow('.media-gallery');
				}
			}
		}
	});

	// Climate facts middle (swap slideshows)
	new Waypoint({
		element: $('#media-gap-3')[0],//.closest('.row')[0],
		handler: function(direction) {
			if(direction === 'up') {
				destroySlideshow('.media-gallery');
				initSlideshow('.media-gallery', 'slideshow2', aspectRatio, true, function() {
				});
			} else {
				destroySlideshow('.media-gallery');
				initSlideshow('.media-gallery', 'slideshow3', aspectRatio, true, function() {
				});
			}
		},
		offset: function() {
            return h
		}
	});

	// Climate facts bottom (play/pause slideshow 2)
	new Waypoint({
		element: $('#climate-facts').closest('.row')[0],
		handler: function(direction) {
			if(direction === 'down') {
				if(!isMobile) {
					// hideNav();
          //whiteNav();
					playSlideshow('.media-gallery');
				}
			} else {
				if(!isMobile) {
					// showNav();
					//redNav();
					stopSlideshow('.media-gallery');
				}
			}
		},
		offset: 'bottom-in-view'
  });
  
  new Waypoint({
		element: $('#history').closest('.row')[0],
		handler: function(direction) {
			if(direction === 'up') {
				if(!isMobile) {
          // hideNav();
          whiteNav();
					playSlideshow('.media-gallery');
				}
			} else {
				if(!isMobile) {
          // showNav();
          redNav();
					stopSlideshow('.media-gallery');
				}
			}
		}
  });

  new Waypoint({
		element: $('#resources').closest('.row')[0],
		handler: function(direction) {
			if(direction === 'up') {
				if(!isMobile) {
          // hideNav();
          redNav()
					playSlideshow('.media-gallery');
				}
			} else {
				if(!isMobile) {
          // showNav();
          whiteNav()
					stopSlideshow('.media-gallery');
				}
			}
		}
	});

	// Press top (play/pause slideshow 1)
	new Waypoint({
		element: $('#press').closest('.row')[0],
		handler: function(direction) {
			if(direction === 'up') {
				if(!isMobile) {
          // hideNav();
          redNav();
					playSlideshow('.media-gallery');
				}
			} else {
				if(!isMobile) {
          // showNav();
          whiteNav();
					stopSlideshow('.media-gallery');
				}
			}
		}
  });
}

function playSlideshow(gallerySelector) {
	var $gallery = $(gallerySelector);
	var flkty = $gallery.data('flickity');
	if(flkty === undefined) {
		//begin polling here?
		return;
	}
	var $slides = $gallery.find(galleryTypes);
	var el = $slides[flkty.selectedIndex];
	if(el && el.nodeName === 'VIDEO') {
    var id = $(el).attr('id');
    videojs(id).currentTime(0);
    //videojs(id).play();
	}
}

function stopSlideshow(gallerySelector) {
	var $gallery = $(gallerySelector);
	var flkty = $gallery.data('flickity');
	if(flkty === undefined) {
		return;
	}
	var $slides = $gallery.find(galleryTypes);
	var el = $slides[flkty.selectedIndex];
	if(el && el.nodeName === 'VIDEO') {
		var id = $(el).attr('id');
		videojs(id).pause();
	}

}

function hideNav() {
	var $nav = $('#navigation');
	if(!$nav.hasClass('hidden')) {
		$nav.addClass('hidden');
	}
}

function showNav() {
	$('#navigation').removeClass('hidden');
}

function redNav() {
	var $nav = $('#navigation');
	if(!$nav.hasClass('red')) {
		$nav.addClass('red');
	}
}

function whiteNav() {
	$('#navigation').removeClass('red');
}

window.mobilecheck = function() {
	var check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
	return check;
}

window.mobileAndTabletcheck = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

// THREE FUNCS
function attach_if_ready() {
  container = $('.three-frame')
  // container will either not exist 
  // OR will already have the three scene set up in it
  if (container[0]){
    init();
    setupDataConsole()
    clearInterval(trying_to_setup)
  }
}

function setIceData () {
  if (londonWeatherData) {
    var start_utc = 1544377035041
    var today = londonWeatherData
    var current_temp = Math.round((parseFloat(today.main.temp) - 273.15) * 100) / 100
    var n_melt_days = 23
    var total_mass = 110000
    var days_elapsed = (Date.now() - start_utc) / 86400000
    var melt_rate = Math.round(total_mass/n_melt_days*100)/100;
    var current_mass = Math.round((total_mass - melt_rate * days_elapsed) * 100) / 100
    iceMeltState = 1 - current_mass / total_mass

    var dataHTML = at_html_data['ice-data']
    dataHTML = dataHTML.replace('<<MELT_RATE>>', melt_rate)
    dataHTML = dataHTML.replace('<<TEMP>>', current_temp)
    dataHTML = dataHTML.replace('<<CURRENT_MASS>>', current_mass)

    dataConsole.html(dataHTML)
    if (!isMobile && bg_key=='three') dataConsole.show()
    else dataConsole.hide()
  }
}

function setupDataConsole() {
  dataConsole = $('<div>')
  
  dataConsole.attr('id','data-console')
  $('.three-frame').append(dataConsole)
  dataConsole.css({
    fontFamily: 'monospace',
    position: 'fixed',
    fontWeight: 'lighter',
    top: window.innerHeight*.2,
    left: '70%',
    fontSize: 15,
    //color: 'red',
    zIndex: 1
  })

  var weatherAPIUrl = 'https://api.openweathermap.org/data/2.5/weather?id=2643743&APPID=705a22e689f9613a9a709ac814037ea0'

  $.get(weatherAPIUrl, (data) => {
    londonWeatherData = data
    setIceData()
  })
}

function init() {
  clock.start()
  mixers = [];

  // Interactive Ref
  // https://github.com/mrdoob/three.js/blob/master/examples/webgl_interactive_cubes.html
  document.addEventListener( 'mousemove', onDocumentMouseMove, false );

  container = document.createElement( 'div' );
  document.body.appendChild( container );

  camera = new THREE.OrthographicCamera( window.innerWidth / -2, window.innerWidth / 2,  window.innerHeight/2, window.innerHeight/-2, 1, 10000 );
  // camera = new THREE.PerspectiveCamera( 40, window.innerWidth / window.innerHeight, 1, 5000 );
  camera.position.set( 0.0, 300, 400 * 4 );

  scene = new THREE.Scene();
  outscene = new THREE.Scene();

  // Lights

  scene.add( new THREE.AmbientLight( 0x888888 ) );

  var directionalLight = new THREE.DirectionalLight( 0xddeeff, 0.2 );
  directionalLight.position.set( 0.0, 0.5, 0.5 ).normalize();
  scene.add( directionalLight );

  var pointLight1 = new THREE.Mesh( new THREE.SphereBufferGeometry( 1, 1, 1 ), new THREE.MeshBasicMaterial( { color: 0x888888 } ) );
  pointLight1.add( new THREE.PointLight( 0x8888dd, 1.0, 300 ) );
  //scene.add( pointLight1 );
  pointLight1.position.x = 0;
  pointLight1.position.y =  250;
  pointLight1.position.z = 350;

  var pointLight2 = new THREE.Mesh( new THREE.SphereBufferGeometry( 1, 1, 1 ), new THREE.MeshBasicMaterial( { color: 0x888888 } ) );
  pointLight2.add( new THREE.PointLight( 0x888888, 1.0, 500 ) );
  //scene.add( pointLight2 );
  pointLight2.position.x = - 100;
  pointLight2.position.y = 220;
  pointLight2.position.z = - 260;

  // BACKGRUND
  var geometry = new THREE.SphereGeometry( 2000, 10, 100 );
  var material = new THREE.MeshBasicMaterial( {color: 0xffffff, side: THREE.DoubleSide} );
  var mesh = new THREE.Mesh( geometry, material );
  scene.add( mesh );

  renderer = new THREE.WebGLRenderer( { antialias: true } );
  renderer.setPixelRatio( window.devicePixelRatio );
  renderer.setSize( window.innerWidth, window.innerHeight );
  
  $('.three-frame').empty()
  $('.three-frame')[0].appendChild( renderer.domElement );

  renderer.gammaInput = true;
  renderer.gammaOutput = true;

  //stats = new Stats();
  //container.appendChild( stats.dom );

  var controls = new THREE.OrbitControls( camera, container );

  window.addEventListener( 'resize', onWindowResize, false );

  initMorph();
}

function initText() {
  
}

function initMorph() {

  var loader = new THREE.TextureLoader();
  var imgTexture = loader.load( 'models/fbx/white.jpg' );
  var thicknessTexture = loader.load( 'models/fbx/white.jpg' );
  imgTexture.wrapS = imgTexture.wrapT = THREE.RepeatWrapping;

  var shader = new TranslucentShader();
  uniforms = THREE.UniformsUtils.clone( shader.uniforms );

  uniforms[ 'map' ].value = imgTexture;
  uniforms[ 'diffuse' ].value = new THREE.Vector3( .8, 0.8, 0.8 );
  uniforms[ 'shininess' ].value = 500;
  uniforms[ 'thicknessMap' ].value = thicknessTexture;
  uniforms[ 'thicknessColor' ].value = new THREE.Vector3( 0.2, 0.24, 0.3 );
  uniforms[ 'thicknessDistortion' ].value = 0.1;
  uniforms[ 'thicknessAmbient' ].value = 1;
  uniforms[ 'thicknessAttenuation' ].value = 4.3;
  uniforms[ 'thicknessPower' ].value = 10.0;
  uniforms[ 'thicknessScale' ].value = 1.0;

  var material = new THREE.ShaderMaterial( {
      uniforms: uniforms,
      vertexShader: shader.vertexShader,
      fragmentShader: shader.fragmentShader,
      lights: true
  } );
  material.transparent = true;
  material.extensions.derivatives = true;

  // OUTLINE
  let vxs =`
    uniform float offset;
    void main() {
      vec4 pos = modelViewMatrix * vec4( position + normal * offset, 1.0 );
      gl_Position = projectionMatrix * pos;
    }
    `

    let fgs =`
    void main(){
      gl_FragColor = vec4( 0.0, 0.0, 0.5, 0.1 );
    }
    `
    let outlineUniforms = {
      offset: {
        type: 'f',
        value: 1
      }
    };

    let outlineMat = new THREE.ShaderMaterial({
      //side: THREE.BackSide,
      uniforms: outlineUniforms,
      vertexShader: vxs,
      fragmentShader: fgs
    });
    var outlineMat2 = new THREE.MeshBasicMaterial( { color: 0x00ff00, side: THREE.BackSide } );

  // LOADER
  var loader = new THREE.FBXLoader();
  loader.load( 'models/fbx/babybeige.fbx', function ( object ) {
      object.traverse( function ( child ) {
          if ( child.isMesh ) {
            if ( child.name =='2') {
              small = child
              small.scale.set(1.5,1.5,1.5)
            }
            else if ( child.name =='1') {
              large = child
              large.scale.set(1.5,1.5, 1.5)
            }
          }
      } );

      // Build Morph Mesh
      morph = large.clone()
      morph.geometry = large.geometry.clone()
      morph.material = material
      window.morph = morph
      morph.castShadow = true;
      morph.receiveShadow = true;

      
      og_morph = large.clone()
      og_morph.children=[]
      //og_morph = new THREE.Mesh(large.geometry.clone(), outlineMat)
      og_morph.position.set(0, 0, -10);
      og_morph.material = outlineMat
      og_morph.material.depthWrite = false;
      scene.add(og_morph)

      morph.children = []
      scene.add( morph );
      animate()
  } );

  //initGUI( uniforms );
}

function setMorphVertices(morph, meshA, meshB, ratio) {
// All inputs are buffer meshes
morph.geometry.attributes.position.needsUpdate = true
var vertsM = morph.geometry.attributes.position.array
var vertsA = meshA.geometry.attributes.position.array
var vertsB = meshB.geometry.attributes.position.array
var e = .0001
for ( var i=0; i < vertsM.length ; i++) {
  vertsM[i] = vertsA[i]*(ratio+e) + vertsB[i]*(1-ratio+e)
}
}

function initGUI( uniforms ) {

  var gui = new dat.GUI();

  var ThicknessControls = function () {

      this.distoration = uniforms[ 'thicknessDistortion' ].value;
      this.ambient = uniforms[ 'thicknessAmbient' ].value;
      this.attenuation = uniforms[ 'thicknessAttenuation' ].value;
      this.power = uniforms[ 'thicknessPower' ].value;
      this.scale = uniforms[ 'thicknessScale' ].value;

  };

  var thicknessControls = new ThicknessControls();
  var thicknessFolder = gui.addFolder( 'Thickness Control' );

  thicknessFolder.add( thicknessControls, 'distoration' ).min( 0.01 ).max( 1 ).step( 0.01 ).onChange( function () {

      uniforms[ 'thicknessDistortion' ].value = thicknessControls.distoration;

  } );

  thicknessFolder.add( thicknessControls, 'ambient' ).min( 0.01 ).max( 5.0 ).step( 0.05 ).onChange( function () {

      uniforms[ 'thicknessAmbient' ].value = thicknessControls.ambient;

  } );

  thicknessFolder.add( thicknessControls, 'attenuation' ).min( 0.01 ).max( 5.0 ).step( 0.05 ).onChange( function () {

      uniforms[ 'thicknessAttenuation' ].value = thicknessControls.attenuation;

  } );

  thicknessFolder.add( thicknessControls, 'power' ).min( 0.01 ).max( 16.0 ).step( 0.1 ).onChange( function () {

      uniforms[ 'thicknessPower' ].value = thicknessControls.power;

  } );

  thicknessFolder.add( thicknessControls, 'scale' ).min( 0.01 ).max( 50.0 ).step( 0.1 ).onChange( function () {

      uniforms[ 'thicknessScale' ].value = thicknessControls.scale;

  } );

  thicknessFolder.open();

}

function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize( window.innerWidth, window.innerHeight );
}

function onDocumentMouseMove( event ) {
  //event.preventDefault();
  mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
  mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
}

function animate() {
  
  requestAnimationFrame( animate );
  if (bg_key == 'three') {
    //var r = Math.sin( clock.getElapsedTime() )
    var r = iceMeltState
    morph.lookAt( new THREE.Vector3( mouse.x*window.innerWidth*10, mouse.y*innerHeight*10, -10000))
    og_morph.lookAt( new THREE.Vector3( mouse.x*window.innerWidth*10, mouse.y*innerHeight*10, -10000))
    setMorphVertices(morph, small, large, r)
    //stats.update();
    render();

    setIceData()
  }
}

function render() {

  renderer.render( outscene, camera );
  renderer.render( scene, camera );

}
